import type { HTMLAttributes } from 'react'

/** The shared toast surface for every card in the bottom-right dock (ToastDock.tsx). */
export function ToastCard({ className = '', ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={`page-enter pointer-events-auto menu-surface hairline rounded-card border p-3 text-sm shadow-lg ${className}`}
      {...props}
    />
  )
}
